export default __webpack_public_path__ + "904f943a9ecad851f1e7cb8dd896af73.svg";